import { useState } from "react";
import { api, errMsg } from "../lib/api";
import { toast } from "sonner";
import { X } from "lucide-react";

export const ReviewDialog = ({ courseId, initial, onClose, onSaved }) => {
  const [rating, setRating] = useState(initial?.rating || 0);
  const [text, setText] = useState(initial?.text || "");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!rating || busy) return;
    setBusy(true);
    try {
      await api.post("/reviews", { course_id: courseId, rating, text: text.trim() });
      toast.success("Thanks for your review! ⭐");
      onSaved({ rating, text: text.trim(), id: initial?.id || "mine" });
      onClose();
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };

  return (
    <div className="review-overlay" onClick={onClose} data-testid="review-dialog">
      <div className="review-modal" onClick={(e) => e.stopPropagation()}>
        <button className="review-close" onClick={onClose} aria-label="Close" data-testid="review-close-btn"><X size={16} /></button>
        <p className="review-eyebrow">🏆 COURSE COMPLETE</p>
        <h3>HOW WAS THE COURSE?</h3>
        <p className="review-sub">Your rating helps other builders pick their next course.</p>
        <div className="review-stars">
          {[1, 2, 3, 4, 5].map((n) => (
            <button key={n} data-testid={`review-star-${n}`} onClick={() => setRating(n)}
              className={n <= rating ? "on" : ""}>★</button>
          ))}
        </div>
        <textarea data-testid="review-text-input" value={text} onChange={(e) => setText(e.target.value)}
          placeholder="What did you build? What did you love? (optional)" rows={3} maxLength={1000}
          className="input-dark text-sm" />
        <button className="btn-primary w-full mt-3 disabled:opacity-40" disabled={!rating || busy}
          onClick={submit} data-testid="review-submit-btn">
          {initial?.id ? "UPDATE REVIEW" : "SUBMIT REVIEW"}
        </button>
      </div>
    </div>
  );
};
